import React from 'react';
import AddNew from '../../components/AddNew';
import TimelineListThread from './TimelineListThread';


const TimelineList = (props) => {
  if (props.didMount !== true) {
    return (
      <div>loading...</div>
    )
  }


  return [{}].concat(props.timeline).map(
    (thread, i) =>
      i === 0
        ? <AddNew
            key={"new"}
            href={"/notes/new"}
            name={"Create a new message"}
            clickAdd={props.click}
          />
        : <TimelineListThread
            key={thread.threadId}
            thread={thread}
            clicked={props.clicked}
          />
  );

}


export default TimelineList;


// WEBPACK FOOTER //
// ./src/containers/Timeline/TimelineList.js